<template>
  <div
    id="loader"
    class="d-flex justify-content-center"
  >
    <div
      class="icon-tennis-ball uk-icon-spin"
      style="line-height: 85vh !important;font-size: 35px;padding:5px"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
};
</script>

<style scoped>

</style>
